import styled, { css } from 'styled-components';
import { ChevronUpIc } from '@dsch/dd-icons';

const triggerStyle = css`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S8};
  min-width: 40px;
  min-height: 40px;
  padding: ${({ theme }) => `${theme.spacing.S8} ${theme.spacing.S12}`};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  ${({ theme }) => theme.donedeal.fontSize.M16};
  font-weight: ${({ theme }) => theme.donedeal.fontWeight.semibold};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
  background: transparent;
  border: 0;
  cursor: pointer;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    background: ${({ theme }) => theme.donedeal.colors.GREY_LIGHTER};
  }
`;

export const MobileTrigger = styled.button`
  ${triggerStyle}
`;

export const DesktopTriggerContent = styled.span`
  ${triggerStyle}
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.M16};
`;

export const ModalHeaderTitle = styled.h2`
  margin: 0;
  ${({ theme }) => theme.donedeal.fontSize.M16};
  font-weight: ${({ theme }) => theme.donedeal.fontWeight.bold};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  right: ${({ theme }) => theme.spacing.S8};
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: ${({ theme }) => theme.spacing.S8};
  background: transparent;
  border: 0;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  cursor: pointer;
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};

  &:hover,
  &:focus-visible {
    background: ${({ theme }) => theme.donedeal.colors.GREY_LIGHTER};
  }
`;

export const ModalHeaderChevron = styled(ChevronUpIc)`
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
`;

export const ModalOptionList = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.spacing.S8} ${theme.spacing.M16}`};
`;

export const ModalOptionRow = styled.div`
  padding: ${({ theme }) => `${theme.spacing.S12} 0`};
`;
